window.dtAnnouncement = function () {
  const dt_announcement = new DataTable('#announcement-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#announcement-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#announcement-datatable', 5); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "date" },
      { "data": "code" },
      { "data": "title" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 